import React from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  SpellbookModifier, 
  UpgradableNumber
} from "@dndModels";
import { COST_UNIT_OPTIONS, SCHOOLS, TIME_UNIT_OPTIONS } from "@dndModels/Constants";

import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
// import SelectObjectBox from '../../../../components/input/selects/SelectObjectBox';

interface Props {
  obj: SpellbookModifier;
  onChange: (changed: SpellbookModifier) => void; 
  disabled: boolean;
  attached_table?: AttachedTable;
}

export default function SpellbookModifierInput({
  obj,
  onChange,
  disabled,
  attached_table
}: Props) {
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox
          name="Only Spells from Schools" 
          options={SCHOOLS}
          values={ obj.schools } 
          disabled={disabled}
          multiple
          auto_sort
          onChange={(changed: string[]) => {
            const new_obj = obj;
            new_obj.schools = changed;
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <UpgradableNumberBox 
          name="Extra Free Spells"
          value={obj.extra_free_spells}
          disabled={disabled}
          attached_table={attached_table}
          onChange={(changed: UpgradableNumber) => {
            const new_obj = obj;
            new_obj.extra_free_spells = changed;
            onChange(new_obj);
          }}
        /> 
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <StringBox
          name="Learning Message"
          value={obj.learning_message}
          disabled={disabled}
          multiline
          onBlur={(changed: string) => {
            const new_obj = obj;
            new_obj.learning_message = changed;
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <UpgradableNumberBox
          name="Time per Level (number)"
          value={obj.time_num_per_spell_level}
          disabled={disabled}
          attached_table={attached_table}
          onChange={(changed: UpgradableNumber) => {
            const new_obj = obj;
            new_obj.time_num_per_spell_level = changed;
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <SelectStringBox
          name="Time per Level (unit)"
          value={`${obj.time_unit}`}
          options={TIME_UNIT_OPTIONS}
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.time_unit = +changed;
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <UpgradableNumberBox
          name="Cost per Level (number)"
          value={obj.cost_per_spell_level}
          disabled={disabled}
          attached_table={attached_table}
          onChange={(changed: UpgradableNumber) => {
            const new_obj = obj;
            new_obj.cost_per_spell_level = changed;
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 3
        }}>
        <SelectStringBox
          name="Cost per Level (unit)"
          value={`${obj.cost_unit}`}
          options={COST_UNIT_OPTIONS}
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.cost_unit = +changed;
            onChange(new_obj);
          }}
        />
      </Grid>
    </Grid>
  );
}

